import { render } from "./UserMessages.vue?vue&type=template&id=fa380e40&scoped=true"
import script from "./UserMessages.vue?vue&type=script&lang=js"
export * from "./UserMessages.vue?vue&type=script&lang=js"

import "./UserMessages.vue?vue&type=style&index=0&id=fa380e40&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa380e40"]])

export default __exports__